module.exports = __webpack_public_path__ + "img/228.fd3147fc.jpg";